import { render, staticRenderFns } from "./bqColorPage.vue?vue&type=template&id=446bfade"
import script from "./bqColorPage.vue?vue&type=script&lang=js"
export * from "./bqColorPage.vue?vue&type=script&lang=js"
import style0 from "./bqColorPage.vue?vue&type=style&index=0&id=446bfade&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports